import React from 'react'
import Header from '../../Header/Header'
import Footer from '../../Footer/Footer'
import First from './First_section/First'
import Last from './Last_section/Last'
import Second from './Second_section/Second'
import Third from './Third_section/Third'


const LifeAtWeb = () => {
  return (
    <>
      <Header />
      <First />
      <Second />
      <Third />
      <Last />
      <Footer />
    </>
  )
}

export default LifeAtWeb